@if (messageService.numberMessages > 0) {
  <div class="message-controls">
    <a (click)="clearMessages()">
      <fa-icon [icon]="faTrash"></fa-icon>
      <span>Clear all</span>
    </a>
  </div>
}

<div class="messages">
  @for (message of messageService.messages; track message) {
    @if (message.sidebarComponent) {
      <ng-container [ngComponentOutlet]="message.sidebarComponent" [ngComponentOutletInputs]="{ message }" />
    } @else {
      <div
        class="message"
        [class.success]="message.status === MessageStatus.SUCCESS"
        [class.warning]="message.status === MessageStatus.WARNING"
        [class.error]="message.status === MessageStatus.ERROR"
      >
        @if (message.title) {
          <div class="title">
            {{ message.title }}
          </div>
        }
        <div class="message-text">
          {{ message.message }}
        </div>
        <div class="message-time">
          {{ message.time | messageTime }}
        </div>
      </div>
    }
  }

  @if (messageService.numberMessages === 0) {
    <div class="no-messages">No messages to display.</div>
  }
</div>
